export default __webpack_public_path__ + "static/Logo-02-052a95c62f411ba31cad364c51129058.png";